import React, { useEffect} from 'react';
import { SearchResult } from "../../../../interface/Server";
import { DropdownContainer, DropdownResult } from '../Header/HeaderStyles';

let dropdownRef: any;

interface Props {
    results: SearchResult[],
    onClickOutside: () => void,
}
// sample search with results: '長椅' OR 'a'
const SearchDropdown: React.FunctionComponent<Props>  = (props: Props) => {
    const handleClick = (e: any) => {
        if(dropdownRef && dropdownRef.contains(e.target)) {
            return;
        }
        props.onClickOutside();
    }
    useEffect(() => {
        window.addEventListener('mousedown', handleClick, false);
        return () => window.removeEventListener('mousedown', handleClick, false);
    }, []);
    return (
        <DropdownContainer 
            ref={(ref: any) => dropdownRef = ref}
        >
            {props.results.length > 0 ? props.results.slice(0, 5).map((result, idx) => 
                <DropdownResult
                    key={`result_${idx}`}
                    onClick={() => window.location.href = result.url}
                    className="search-result"
                >
                    {result.content}
                </DropdownResult>
            ) :
                <DropdownResult className="empty-search-result">Your search did not match any results.</DropdownResult>
            }
        </DropdownContainer>
    );
}

export default SearchDropdown;